export default function buildPageTitle(page?: string, section?: string) {
  const appName = "Ameelio Connect";
  const sectionText = section ? ` - ${section}` : "";
  return page ? `${page}${sectionText} - ${appName}` : appName;
}
